import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  breakpoint: {
    mobileBreakpoint: 'sm' // This is equivalent to a value of 960
  },
  theme: {
    themes: {
      light: {
        primary: '#000000',
        secondary: '#b0bec5',
        link: 'red',
        accent: '#8c9eff',
        error: '#b71c1c',
      },

    },
  },
});
